<div class="input-container" [ngClass]="{ 'input-container_disabled': disabled,'input-bottom-line':showButtonBorder }"
  >
  <span class="input-left-icon input-icon fa" [ngClass]="iconClass" *ngIf="iconClass && iconPosition === 'left'"
    (click)="onIconClick.emit($event)"></span>
  <input type="text" *ngIf="!multiple" [(ngModel)]="value" class="input-text" [ngStyle]="{ width: width }"
  [ngClass]="{
      'input-left': iconClass && iconPosition === 'left',
      'input-right': iconClass && iconPosition === 'right'
    }"
     (focus)="focus($event)" (blur)="blur($event)" [disabled]="disabled" (keyup)="keyUp($event)"
    [placeholder]="placeholder" />
  <textarea [(ngModel)]="value" *ngIf="multiple" class="input-textarea" [ngStyle]="{ width: width }" [style.resize]="resizeable?'auto':'none'"
    [style.width]="width||''" (focus)="focus($event)" (blur)="blur($event)" [style.height]="height||''"
    [disabled]="disabled" (keyup)="keyUp($event)" [placeholder]="placeholder" [maxlength]="maxlength"></textarea>
  <span class="input-right-icon input-icon fa" [ngClass]="iconClass" *ngIf="iconClass && iconPosition === 'right'"
    (click)="onIconClick.emit($event)"></span>
</div>
